export const PR_ITEMS_TAB_ID = "PR-Items";
export const PR_APPROVERS_TAB_ID = "PR-Approvers";
export const PR_ATTACHMENTS_TAB_ID = "PR-Attachments";
export const PR_COMMENTS_TAB_ID = "PR-Comments";